module.exports = __webpack_public_path__ + "445b2e90d615e592c5b9479ed0e0eec5.svg";